import { render } from "./BookingConfirmationEmail.vue?vue&type=template&id=a8601a78&ts=true&lang=pug"
import script from "./BookingConfirmationEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingConfirmationEmail.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__